export const SANITIZATION_CONFIG = {
    ALLOWED_TAGS: [
        'b', 'strong', 'i', 'em', 'u', 'strike', 's', 'del',
        'ul', 'ol', 'li',
        'p', 'br', 'div', 'span',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
    ],
    ALLOWED_STYLE_TAGS: [
        'p', 'div', 'span', 'b', 'strong', 'i', 'em', 'u', 'strike', 's', 'del',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li'
    ],
    ALLOWED_CSS_PROPERTIES: [
        'font-weight', 'font-style', 'text-decoration', 'font-size', 'font-family',
        'color', 'background-color', 'background', 'text-align'
    ],
    DANGEROUS_TAGS: [
        'script', 'iframe', 'form', 'input', 'textarea', 'button', 'select', 'option',
        'object', 'embed', 'applet', 'meta', 'base', 'link', 'style',
        'svg', 'math', 'details', 'summary'
    ],
    DANGEROUS_ATTRIBUTES: [
        'onload', 'onerror', 'onclick', 'onmouseover', 'onmouseout', 'onmousedown',
        'onmouseup', 'onmousemove', 'onkeydown', 'onkeyup', 'onkeypress',
        'onfocus', 'onblur', 'onchange', 'onsubmit', 'onreset', 'onselect',
        'onabort', 'oncanplay', 'oncanplaythrough', 'ondurationchange',
        'onemptied', 'onended', 'oninput', 'oninvalid', 'onloadeddata',
        'onloadedmetadata', 'onloadstart', 'onpause', 'onplay', 'onplaying',
        'onprogress', 'onratechange', 'onseeked', 'onseeking', 'onstalled',
        'onsuspend', 'ontimeupdate', 'onvolumechange', 'onwaiting',
        'onafterprint', 'onbeforeprint', 'onbeforeunload', 'onerror',
        'onhashchange', 'onmessage', 'onoffline', 'ononline', 'onpagehide',
        'onpageshow', 'onpopstate', 'onresize', 'onstorage', 'onunload',
        'oncontextmenu', 'ondblclick', 'ondrag', 'ondragend', 'ondragenter',
        'ondragleave', 'ondragover', 'ondragstart', 'ondrop', 'onscroll',
        'onwheel', 'oncopy', 'oncut', 'onpaste',
        'srcdoc', 'formaction'
    ],
    DANGEROUS_URL_SCHEMES: [
        'javascript:', 'vbscript:', 'file:', 'about:',
        'chrome:', 'chrome-extension:', 'moz-extension:'
    ],

  DANGEROUS_DATA_URLS: [
    'data:text/html', 'data:text/javascript', 'data:application/',
    'data:text/css', 'data:text/xml'
  ],
  DANGEROUS_CSS_VALUES: [
    'javascript:', 'expression(', 'url(javascript:', 'url(data:text',
    'url(vbscript:', '-moz-binding', 'behavior:'
  ],
  DANGEROUS_CSS_PROPERTIES: [
    'position', 'z-index', 'top', 'left', 'right', 'bottom',
    'width', 'height'
  ],
  DANGEROUS_META_ATTRIBUTES: [
    'http-equiv', 'refresh', 'content'
  ],
  REPLACEMENT_TEXT: ''
};
